const REST_POLL_MS = 100
const REST_MAX_MS = 1_500

// Calls onRest once element has stopped moving on screen — two measurements
// a poll apart that agree — or once REST_MAX_MS has passed, whichever comes
// first. The first measurement waits a frame, so a smooth scroll requested
// just before has begun moving. Measuring rather than listening for
// `scrollend` covers WebViews without that event and a scroll that never had
// to move. Returns a cancel that drops a pending call.
export function whenAtRest(element: Element, onRest: () => void): () => void {
  let last: DOMRect | undefined
  let waitedMs = 0
  let timer: ReturnType<typeof setTimeout> | undefined
  const poll = () => {
    waitedMs += REST_POLL_MS
    const now = element.getBoundingClientRect()
    if (
      (last && now.x === last.x && now.y === last.y) ||
      waitedMs >= REST_MAX_MS
    ) {
      timer = undefined
      onRest()
      return
    }
    last = now
    timer = setTimeout(poll, REST_POLL_MS)
  }
  const frame = requestAnimationFrame(() => {
    last = element.getBoundingClientRect()
    timer = setTimeout(poll, REST_POLL_MS)
  })
  return () => {
    cancelAnimationFrame(frame)
    clearTimeout(timer)
  }
}
